// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1qtZc","header":"ClearentDisclaimer_header__1MygZ","inner":"ClearentDisclaimer_inner__3C81Z"};